import React from 'react';
import { cn } from '@ui/lib/utils';

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
    children: React.ReactNode;
    container?: boolean;
}

export function Section({ children, className, container = false, ...props }: SectionProps) {
    return (
        <section
            className={cn(
                "mb-8",
                container && "container mx-auto px-4",
                className
            )}
            {...props}
        >
            {children}
        </section>
    );
}
